const Footer = () => {
  return (
    <footer className="bg-green-100 text-green-800 text-sm py-3 px-6 flex justify-between items-center mt-6 shadow-inner">
      <p>© {new Date().getFullYear()} Farmer Dashboard. All rights reserved.</p>
      <p>Made with 💚 for Indian Farmers</p>
    </footer>
  );
};

export default Footer;
